import {
  lds_ellipsis,
  loadingContainer,
  loadingOverlay
} from './Loading.module.css';

import classNames from 'classnames';

export default function Loading({ isOverlay = true, className }) {
  return (
    <div className={classNames('lg:hidden', className)}>
      <div className={loadingContainer}>
        <div className={lds_ellipsis}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      {isOverlay && <div className={loadingOverlay}></div>}
    </div>
  );
}
